import React from "react";
import ReactQuill from "react-quill";
import "react-quill/dist/quill.snow.css";

const EditorComponent = (props: any) => {
  const { value, onChange } = props;

  const modules = {
    toolbar: [
      [{ "header": [1, 2, 3, 4, 5, 6, false] }],
      ["bold", "italic", "underline", "strike", "blockquote"],
      [{ "list": "ordered" }, { "list": "bullet" }, { "indent": "-1" }, { "indent": "+1" }],
      [{ "align": [] }],
      ["link"],
      ["clean"],
      [{ "background": [] }],
      [{ "color": [] }],
      [{ "font": [] }],
    ]
  };

  const formats = [
    "header", "bold", "italic", "underline", "strike", "blockquote",
    "list", "bullet", "indent",
    "link",
    "align", "background", "color", "font"
  ];

  return (
    <ReactQuill
      theme="snow"
      value={value}
      onChange={onChange}
      modules={modules}
      formats={formats}
    />
  );
}

export default EditorComponent;
